import { DivPaperStyled, ModalStyled, Title } from '../../Modals.styled';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../setup';
import { modalStyles } from '../../ModalStyles';
import { Backdrop, Fade } from '@mui/material';
import { KTSVG } from '../../../../_metronic/helpers';
import { FooterStyled } from '../../Modals/Modals.styled';
import { useEffect, useState } from 'react';
import { actionTypes } from '../../../modules/auth/redux/PagesRedux';

const RemarksMessageModal = ({open, setOpen, formik, formFor}) => {
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const classes = modalStyles({fontSize: fontSize})
    const openRemarksMessage = useSelector<RootState>(({pages}) => pages.openRemarksMessage) 
    const dispatch = useDispatch()

    const handleClose = () => {
        setOpen(false)
        if(formik?.setFieldValue){
            formik?.setFieldValue(`${formFor}.remarks`, '')
        }
    }

    useEffect(() => {
        if(openRemarksMessage === true && open === false && (formik?.values && formik?.values[formFor]?.remarks)){
            setOpen(true)
            dispatch({type: actionTypes.SetOpenRemarksMessage, payload: false})
        }
    }, [openRemarksMessage])
    
    return (
        <ModalStyled
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            fontSize={fontSize}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <DivPaperStyled className={classes.paperRemarks}>
                    <div className="row">
                        <div className="d-flex align-items-center justify-content-end">
                            <div className="col-12 d-flex btn btn-icon btn-sm btn-active-light-primary" onClick={handleClose}>
                                 <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="row justify-content-center">
                            <div className="col-12 d-flex justify-content-center">
                                <KTSVG path='/media/icons/bootstrap/exclamation-circle.svg' className='svg-icon svg-icon-3x text-warning'/>
                            </div>
                            <div className="col-12 mt-5 d-flex justify-content-center">
                                <Title fontSize={fontSize}>{formik?.values?.remarks ? formik?.values?.remarks : formik?.remarks ? formik?.remarks : formik?.values ? formik?.values[formFor]?.remarks : formik ? (formik[formFor] ? (formik[formFor].remarks ? formik[formFor].remarks : formik[formFor].Remarks) : '') : ''}</Title>
                            </div>
                        </div>
                        <div className="row mt-4 mb-3">
                            <FooterStyled fontSize={fontSize} className="col-12 d-flex justify-content-center">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        handleClose()
                                    }}
                                >
                                    Close
                                </button>
                            </FooterStyled>
                        </div>
                    </>
                </DivPaperStyled>
            </Fade>
        </ModalStyled>
    )
}

export default RemarksMessageModal